"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeekRange = exports.getWeekDays = void 0;
var moment = require("moment");
exports.getWeekDays = function (weekStart, amount) {
    var days = [weekStart];
    for (var i = 1; i < amount; i += 1) {
        days.push(moment(weekStart)
            .add(i, 'days')
            .toDate());
    }
    return days;
};
exports.getWeekRange = function (date, range) {
    var startDate = moment(date).startOf('isoWeek');
    return {
        from: startDate.toDate(),
        to: startDate
            .add(range - 1, 'days')
            .toDate(),
    };
};
//# sourceMappingURL=utils.js.map